export enum UserResponseMetricType {
  risks = 'risks',
  lifeChallenges = 'life-challenges',
  priorities = 'priorities',
  growthAreas = 'growth-areas',
  strengths = 'strengths',
  focuses = 'focuses',
}
